<template>
  <div id="filePreview">
    <!-- 头部导航 -->
    <header class="preview-header">
      <div class="header-top">
        <div class="breadcrumb-wrapper">
          <nav class="breadcrumb">
            <span
              class="breadcrumb-item breadcrumb-link"
              @click="goToProject"
              :title="'返回项目首页'"
            >
              <i class="el-icon-arrow-left"></i>
              <span class="link-text">{{ projectName || '项目首页' }}</span>
            </span>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item breadcrumb-link" @click="goToProject">
              {{ documentName || '文档详情' }}
            </span>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item breadcrumb-current">正文</span>
          </nav>
        </div>

        <div class="header-actions">
          <el-button
            class="download-btn"
            size="small"
            icon="el-icon-download"
            @click="downloadFile"
          >
            下载文件
          </el-button>
        </div>
      </div>

      <!-- 文档信息区 -->
      <div class="document-info">
        <h1 class="document-title">{{ documentName || '文件预览' }}</h1>
        <div class="document-meta">
          <div class="meta-item">
            <i class="el-icon-calendar"></i>
            <span>{{ formattedCreateTime }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <i class="el-icon-eye"></i>
            <span>浏览 {{ viewCount || '500+' }}</span>
          </div>
<!--          <div class="meta-divider"></div>-->
<!--          <div class="meta-item">-->
<!--            <i class="el-icon-file"></i>-->
<!--            <span>{{ fileExt.toUpperCase() || '未知' }}</span>-->
<!--          </div>-->
        </div>
      </div>
    </header>

    <!-- 文件预览区域 -->
    <main class="preview-content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner">
          <div class="spinner-ring"></div>
        </div>
        <p class="loading-text">正在加载文件...</p>
      </div>

      <!-- 视频预览 -->
      <div v-else-if="documentType === 'VEDIO'" class="media-preview video-preview">
        <div class="preview-frame">
          <video
            :src="decodedFilePath"
            controls
            class="preview-video"
            poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'%3E%3Crect fill='%231a1a1a' width='400' height='300'/%3E%3Ctext fill='%23666' font-family='sans-serif' font-size='24' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3E视频预览%3C/text%3E%3C/svg%3E"
          ></video>
        </div>
      </div>

      <!-- Office文档预览 -->
      <div v-else-if="isOfficeDoc" class="iframe-preview office-preview">
        <div class="preview-frame">
          <iframe
            :src="officePreviewUrl"
            class="preview-iframe"
            frameborder="0"
            :title="documentName"
          ></iframe>
        </div>
      </div>

      <!-- 图片预览 -->
      <div v-else-if="isImage" class="media-preview image-preview">
        <div class="preview-frame">
          <el-image
            :src="decodedFilePath"
            fit="contain"
            class="preview-image"
            :alt="documentName"
            lazy
          ></el-image>
        </div>
        <div class="image-info">
          <span>{{ getImageInfo() }}</span>
        </div>
      </div>

      <!-- 其他文件预览（PDF等） -->
      <div v-else-if="previewUrl" class="iframe-preview file-preview">
        <div class="preview-frame">
          <iframe
            :src="previewUrl"
            class="preview-iframe"
            frameborder="0"
            :title="documentName"
          ></iframe>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-container">
        <div class="empty-icon">
          <i class="el-icon-folder-opened"></i>
        </div>
        <h3 class="empty-title">暂无预览文件</h3>
        <p class="empty-desc">该文档没有可预览的文件内容</p>
        <el-button class="empty-btn" size="small" @click="goToProject">返回列表</el-button>
      </div>
    </main>
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64;
import { getDocumentDetail } from '@/request/api.js';

export default {
  name: 'filePreview',
  data() {
    return {
      loading: false,
      documentName: '',
      createTime: '',
      filePath: '',
      documentType: '',
      viewCount: '1000',
      projectName: '',
      parentProjectId: '',
    }
  },
  computed: {
    decodedFilePath() {
      if (!this.filePath) return ''
      try {
        return decodeURIComponent(this.filePath)
      } catch (e) {
        return this.filePath
      }
    },
    pureFilePath() {
      try {
        return (this.decodedFilePath || '').split('?')[0] || ''
      } catch (e) {
        return ''
      }
    },
    formattedCreateTime() {
      if (!this.createTime) return '--'
      try {
        return this.$moment(this.createTime).format('YYYY/MM/DD HH:mm')
      } catch (e) {
        return this.createTime
      }
    },
    fileExt() {
      const pure = this.pureFilePath
      const match = pure.match(/\.([a-zA-Z0-9]+)$/)
      return match ? match[1].toLowerCase() : ''
    },
    isImage() {
      return /^(jpg|jpeg|png|gif|bmp|webp)$/i.test(this.fileExt)
    },
    isOfficeDoc() {
      return /^(doc|docx|xls|xlsx|ppt|pptx)$/i.test(this.fileExt)
    },
    officePreviewUrl() {
      if (!this.decodedFilePath) return ''
      return 'https://view.officeapps.live.com/op/embed.aspx?src='
          + encodeURIComponent(this.decodedFilePath)
          + '&action=embedview'
    },
    previewUrl() {
      if (!this.decodedFilePath) return ''
      if (this.documentType === 'VEDIO' || this.isImage || this.isOfficeDoc) return ''
      try {
        const url = this.decodedFilePath
        let previewUrl = 'https://wmzh.life-oasis.com/kkFileView/onlinePreview?url='
            + encodeURIComponent(Base64.encode(url))
        if (this.fileExt === 'pdf') {
          previewUrl += '&officePreviewType=pdf'
        }
        return previewUrl
      } catch (e) {
        console.error('生成预览地址失败', e)
        return ''
      }
    }
  },
  created() {
    const documentId = this.$route.query.documentId
    if (documentId) {
      this.fetchDocument(documentId)
    }
  },
  methods: {
    async fetchDocument(documentId) {
      this.loading = true
      try {
        const res = await getDocumentDetail(documentId)
        if (res.code === 200 && res.data) {
          const data = res.data
          this.documentName = data.documentName || ''
          this.createTime = data.createTime || ''
          this.filePath = data.filePath || ''
          this.documentType = data.documentType || ''
          this.projectName = data.projectName || ''
          this.parentProjectId = data.parentProjectId || ''
          this.viewCount=data.viewCount || ''
          // 设置页面标题
          document.title = this.documentName
              ? `${this.documentName} - 文件预览`
              : '文件预览'
        } else {
          this.$message.error(res.msg || '获取文档信息失败')
        }
      } catch (e) {
        console.error('获取文档详情失败', e)
        this.$message.error('获取文档信息失败')
      } finally {
        this.loading = false
      }
    },
    goToProject() {
      if (this.parentProjectId) {
        window.location.href = `https://zhjs.article.life-oasis.com/project/${this.parentProjectId}`
      }
    },
    downloadFile() {
      if (this.decodedFilePath) {
        window.open(this.decodedFilePath, '_blank')
      }
    },
    getImageInfo() {
      if (!this.decodedFilePath) return ''
      const ext = this.fileExt.toUpperCase()
      return `${ext} 图片`
    }
  }
}
</script>

<style lang="scss" scoped>
#filePreview {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

// ========== 头部导航 ==========
.preview-header {
  flex-shrink: 0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 0 24px;
  border-bottom: 1px solid #e8eef3;
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #f0f2f5;
}

.breadcrumb-wrapper {
  flex: 1;
  min-width: 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #646a73;

  .breadcrumb-item {
    display: flex;
    align-items: center;

    &.breadcrumb-link {
      color: #409eff;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: #66b1ff;
        text-decoration: underline;
      }

      i {
        font-size: 14px;
        margin-right: 6px;
        color: #8c939d;

        &:hover {
          color: #409eff;
        }
      }

      .link-text {
        margin-left: 2px;
      }
    }

    &.breadcrumb-current {
      color: #2d3436;
      font-weight: 500;
    }
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: #c0c4cc;
    font-size: 12px;
  }
}

.header-actions {
  flex-shrink: 0;

  .download-btn {
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
    border: none;
    color: #fff;
    padding: 6px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #66b1ff 0%, #8cc5ff 100%);
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// ========== 文档信息区 ==========
.document-info {
  padding: 20px 0;

  .document-title {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 12px 0;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 800px;
  }

  .document-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 13px;
    color: #8c939d;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 5px;

      i {
        font-size: 14px;
        color: #adb5bd;
      }
    }

    .meta-divider {
      width: 1px;
      height: 14px;
      background: #e8eef3;
    }
  }
}

// ========== 预览内容区域 ==========
.preview-content {
  flex: 1;
  position: relative;
  margin: 16px;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

// ========== 加载状态 ==========
.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafbfc;

  .loading-spinner {
    width: 48px;
    height: 48px;
    position: relative;
    margin-bottom: 16px;

    .spinner-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 3px solid #f0f0f0;
      border-top-color: #409eff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    &::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      right: 3px;
      bottom: 3px;
      border: 3px solid transparent;
      border-top-color: #66b1ff;
      border-radius: 50%;
      animation: spin 0.8s linear infinite reverse;
    }
  }

  .loading-text {
    font-size: 14px;
    color: #8c939d;
    margin: 0;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// ========== 媒体预览（视频、图片） ==========
.media-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .preview-frame {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
}

.video-preview .preview-frame {
  background: #0a0a0a;

  .preview-video {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    outline: none;
    background: #1a1a1a;
  }
}

.image-preview {
  .preview-frame {
    background: #f8f9fa;
    padding: 20px;

    .preview-image {
      max-width: 100%;
      max-height: calc(100% - 60px);
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }
  }

  .image-info {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
  }
}

// ========== iframe预览（Office、PDF等） ==========
.iframe-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .preview-frame {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .preview-iframe {
    width: 100%;
    height: 100%;
    border: none;
    background: #ffffff;
  }
}

// ========== 空状态 ==========
.empty-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafbfc;

  .empty-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #e8f4fd 0%, #f0f7ff 100%);
    border-radius: 20px;
    margin-bottom: 20px;

    i {
      font-size: 40px;
      color: #409eff;
    }
  }

  .empty-title {
    font-size: 16px;
    font-weight: 600;
    color: #2d3436;
    margin: 0 0 8px 0;
  }

  .empty-desc {
    font-size: 13px;
    color: #8c939d;
    margin: 0 0 24px 0;
  }

  .empty-btn {
    background: #f0f2f5;
    color: #409eff;
    border: none;
    padding: 8px 24px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #409eff;
      color: #fff;
    }
  }
}

// ========== 响应式适配 ==========
@media screen and (max-width: 768px) {
  .preview-header {
    padding: 0 16px;
  }

  .breadcrumb {
    font-size: 12px;
  }

  .document-title {
    font-size: 16px;
    max-width: 100%;
  }

  .document-meta {
    flex-wrap: wrap;
    gap: 12px;
  }

  .preview-content {
    margin: 8px;
    border-radius: 8px;
  }
}
</style>

